import { serviceName } from '../resources/serviceConstants';
import {
  BILLING_ENTITY,
  BILLING_TYPE,
  CLIENT_DETAILS,
  CLOUD_PROVIDER_MASTER,
  CONSUMPTION_TYPE_MASTER,
  COST_SPLIT,
  DELIVERY_METHODOLOGY_MASTER,
  FP_BILLING_TYPE,
  MASTER_DEPARTMENT,
  MASTER_PROJECT_NAME,
  OPPORTUNITIES_MASTER,
  PROJECT_CUSTOMER_TYPE_MASTER,
  PROJECT_MANAGEMENT_PROJECT_DETAILS_LEGACY_VERTICALS,
  PROJECT_OFFERINGS_MASTER,
  PROJECT_OVERVIEW,
  REGION_COUNTRY,
  REVENUE_SPLIT,
  SALES_VERTICAL_MASTER,
  SENIOR_MANAGER,
  SPONSOR,
  TECHNOLOGY_MASTER,
  TM_BILLING_TYPE,
  VERTICAL,
} from '../resources/endPoint';

export const getRegionsData = () => {
  return {
    url: REGION_COUNTRY,
    method: 'get',
    headers: { 'content-type': 'application/json' },
    authRequired: false,
    csrfToken: true,
    service: serviceName.MASTER_MS,
  };
};

export const getSponsorsData = () => {
  return {
    url: SPONSOR,
    method: 'get',
    headers: { 'content-type': 'application/json' },
    authRequired: false,
    csrfToken: true,
    service: serviceName.MASTER_MS,
  };
};

export const getSponsorPartnersData = (sponsorId) => {
  return {
    url: `${SPONSOR}?sponsor=${sponsorId}`,
    method: 'get',
    headers: { 'content-type': 'application/json' },
    authRequired: false,
    csrfToken: true,
    service: serviceName.MASTER_MS,
  };
};

export const regionCountryData = (regionId) => {
  if (regionId === undefined || regionId === null) {
    return null;
  }

  return {
    url: `${REGION_COUNTRY}?region=${regionId}`,
    method: 'get',
    headers: { 'content-type': 'application/json' },
    authRequired: false,
    csrfToken: true,
    service: serviceName.MASTER_MS,
  };
};

export const getVerticalData = () => {
  return {
    url: VERTICAL,
    method: 'get',
    headers: { 'content-type': 'application/json' },
    authRequired: false,
    csrfToken: true,
    service: serviceName.MASTER_MS,
  };
};

export const getProjectDetailsLegacyVerticalData = () => {
  return {
    url: PROJECT_MANAGEMENT_PROJECT_DETAILS_LEGACY_VERTICALS,
    method: 'get',
    headers: { 'content-type': 'application/json' },
    authRequired: false,
    csrfToken: true,
    service: serviceName.PROJECT_MS,
  };
};

export const costSplitData = () => {
  return {
    url: COST_SPLIT,
    method: 'get',
    headers: { 'content-type': 'application/json' },
    authRequired: false,
    csrfToken: true,
    service: serviceName.MASTER_MS,
  };
};

export const revenueSplitData = () => {
  return {
    url: REVENUE_SPLIT,
    method: 'get',
    headers: { 'content-type': 'application/json' },
    authRequired: false,
    csrfToken: true,
    service: serviceName.MASTER_MS,
  };
};

export const fpBillingTypeData = () => {
  return {
    url: FP_BILLING_TYPE,
    method: 'get',
    headers: { 'content-type': 'application/json' },
    authRequired: false,
    csrfToken: true,
    service: serviceName.MASTER_MS,
  };
};

export const tmBillingTypeData = () => {
  return {
    url: TM_BILLING_TYPE,
    method: 'get',
    headers: { 'content-type': 'application/json' },
    authRequired: false,
    csrfToken: true,
    service: serviceName.MASTER_MS,
  };
};

export const billingTypeData = () => ({
  url: `${BILLING_TYPE}?cb=${Date.now()}`,
  method: 'get',
  headers: { 'content-type': 'application/json' },
  authRequired: false,
  csrfToken: true,
  service: serviceName.MASTER_MS,
});

export const clientDetailsData = () => {
  return {
    url: CLIENT_DETAILS,
    method: 'get',
    headers: { 'content-type': 'application/json' },
    authRequired: false,
    csrfToken: true,
    service: serviceName.MASTER_MS,
  };
};

export const billingEntityData = () => {
  return {
    url: BILLING_ENTITY,
    method: 'get',
    headers: { 'content-type': 'application/json' },
    authRequired: false,
    csrfToken: true,
    service: serviceName.MASTER_MS,
  };
};

export const seniorManagerData = () => {
  return {
    url: SENIOR_MANAGER,
    method: 'get',
    headers: { 'content-type': 'application/json' },
    authRequired: false,
    csrfToken: true,
    service: serviceName.MASTER_MS,
  };
};

export const masterProjectNameData = () => {
  return {
    url: MASTER_PROJECT_NAME,
    method: 'get',
    headers: { 'content-type': 'application/json' },
    authRequired: false,
    csrfToken: true,
    service: serviceName.MASTER_MS,
  };
};

export const departmentData = () => {
  return {
    url: MASTER_DEPARTMENT,
    method: 'get',
    headers: { 'content-type': 'application/json' },
    authRequired: false,
    csrfToken: true,
    service: serviceName.MASTER_MS,
  };
};

export const salesVerticalData = () => ({
  url: SALES_VERTICAL_MASTER,
  method: 'get',
  headers: { 'content-type': 'application/json' },
  authRequired: false,
  csrfToken: true,
  service: serviceName.MASTER_MS,
});

export const projectOfferingData = (verticalId) => ({
  url: `${PROJECT_OFFERINGS_MASTER}?verticalId=${verticalId}`,
  method: 'get',
  headers: { 'content-type': 'application/json' },
  authRequired: false,
  csrfToken: true,
  service: serviceName.MASTER_MS,
});

export const opportunityData = () => ({
  url: OPPORTUNITIES_MASTER,
  method: 'get',
  headers: { 'content-type': 'application/json' },
  authRequired: false,
  csrfToken: true,
  service: serviceName.MASTER_MS,
});

export const technologyData = () => ({
  url: TECHNOLOGY_MASTER,
  method: 'get',
  headers: { 'content-type': 'application/json' },
  authRequired: false,
  csrfToken: true,
  service: serviceName.MASTER_MS,
});

export const deliveryMethodologyData = () => ({
  url: DELIVERY_METHODOLOGY_MASTER,
  method: 'get',
  headers: { 'content-type': 'application/json' },
  authRequired: false,
  csrfToken: true,
  service: serviceName.MASTER_MS,
});

export const customerTypeData = () => ({
  url: PROJECT_CUSTOMER_TYPE_MASTER,
  method: 'get',
  headers: { 'content-type': 'application/json' },
  authRequired: false,
  csrfToken: true,
  service: serviceName.MASTER_MS,
});

export const consumptionTypeData = () => ({
  url: CONSUMPTION_TYPE_MASTER,
  method: 'get',
  headers: { 'content-type': 'application/json' },
  authRequired: false,
  csrfToken: true,
  service: serviceName.MASTER_MS,
});

export const cloudProviderData = () => ({
  url: CLOUD_PROVIDER_MASTER,
  method: 'get',
  headers: { 'content-type': 'application/json' },
  authRequired: false,
  csrfToken: true,
  service: serviceName.MASTER_MS,
});

export const getArchitectNamesData = (payload, filterName = 'architect-names') => ({
  url: `${PROJECT_OVERVIEW}/filters/${filterName}`,
  method: 'post',
  headers: { 'content-type': 'application/json' },
  authRequired: false,
  csrfToken: true,
  payload,
  service: serviceName.PROJECT_MS,
});
